import React from 'react';

import StepWithOptions from 'containers/Quiz/StepWithOptions';

import { LOVERS_TRACKING, QUIZ_ROUTE } from '..';

const CHOICES = [
  {
    id: 1,
    text: 'components.LoversQuiz.Steps.Tone.choices.1',
    tracking: 'soft',
  },
  {
    id: 2,
    text: 'components.LoversQuiz.Steps.Tone.choices.2',
    tracking: 'passionate',
  },
  {
    id: 3,
    text: 'components.LoversQuiz.Steps.Tone.choices.3',
    tracking: 'hard',
  },
];

const section = {
  sectionName: 'tone',
  choices: CHOICES,
};

const Tone = () => {
  return (
    <StepWithOptions
      section={section}
      question={{ id: 'components.LoversQuiz.Steps.Tone.question' }}
      tracking={{ name: LOVERS_TRACKING, url: `${QUIZ_ROUTE}/tone` }}
    />
  );
};

export default Tone;
